// (function () {
//   const fixEmptyButton = (btn) => {
//     btn.setAttribute('tabindex', '-1');
//     btn.setAttribute('aria-hidden', 'true');
//     btn.setAttribute('role', 'presentation');
//   };

//   const observer = new MutationObserver(() => {
//     const btn = document.querySelector('.onward-opt-out-link');

//     if (btn) {
//       fixEmptyButton(btn);
//     }
//   });

//   observer.observe(document.documentElement, {
//     childList: true,
//     subtree: true
//   });
// })();


(function () {
  function patchKlaviyoForm(form) {
    if (form.dataset.a11yOnInputFixed) return;
    form.dataset.a11yOnInputFixed = "true";

    // Remove aria-live if needed (optional)
    form.removeAttribute("aria-live");

    // Prevent automatic submission triggered by scripts
    const originalSubmit = form.submit;

    form.submit = function () {
      // Block programmatic auto-submit
      console.warn("Blocked automatic form submission (WCAG 3.2.2)");
      return false;
    };

    // Allow user-initiated submits only
    form.addEventListener(
      "submit",
      function (e) {
        if (!e.isTrusted) {
          e.preventDefault();
        }
      },
      true
    );
  }

  function scan(node) {
    if (!node.querySelectorAll) return;

    node
      .querySelectorAll("form.klaviyo-form")
      .forEach(patchKlaviyoForm);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach(scan);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  scan(document);
})();







// (function () {
//   function removeInvalidAriaControls() {
//     document.querySelectorAll('#onward-info-button[aria-controls]').forEach((el) => {
//       const id = el.getAttribute('aria-controls');
//       if (!id) return;

//       if (!document.getElementById(id)) {
//         el.removeAttribute('aria-controls');
//       }
//     });
//   }

//   // Run immediately
//   removeInvalidAriaControls();

//   // Watch EVERYTHING
//   const observer1 = new MutationObserver(() => {
//     removeInvalidAriaControls();
//   });

//   observer1.observe(document.documentElement, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['aria-controls'],
//   });

//   // Extra fallback in case framework keeps re-adding it
//   setInterval(removeInvalidAriaControls, 1000);
// })();






// function applyTolstoyLabels() {
//   const previousIcons = document.querySelectorAll('.tolstoy-previous-button svg');
//   const nextIcons = document.querySelectorAll('.tolstoy-next-button svg');

//   previousIcons.forEach(svg => {
//     svg.setAttribute('role', 'img');
//     svg.setAttribute('aria-label', 'previous');
//     svg.removeAttribute('aria-hidden');
//     svg.setAttribute('data-a11y-fixed', 'true'); // prevent reprocessing
//   });

//   nextIcons.forEach(svg => {
//     svg.setAttribute('role', 'img');
//     svg.setAttribute('aria-label', 'next');
//     svg.removeAttribute('aria-hidden');
//     svg.setAttribute('data-a11y-fixed', 'true');
//   });
// }

// // Run once immediately
// applyTolstoyLabels();

// // Watch for dynamically added content
// const observer = new MutationObserver(() => {
//   applyTolstoyLabels();
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true
// });







